import {
  getAll,
  getPage,
  getDetail,
  modifyObj,
  getMyPage,
  getMyUserGroupPage,
  addProcessRemark,
} from '@/api/drivercarddataresultserv'

export default {
  state: {
    state_DriverCardDataResult_GetAllResult: null,
    state_DriverCardDataResult_GetPageResult: null,
    state_DriverCardDataResult_GetDetailResult: null,
    state_DriverCardDataResult_ModifyObjResult: null,
    state_DriverCardDataResult_GetMyPageResult: null,
    state_DriverCardDataResult_GetMyUserGroupPageResult: null,
    state_DriverCardDataResult_AddProcessRemarkResult: null,
  },
  mutations: {
    SET_DRIVERCARDDATARESULT_GETALL_RESULT: (state, rst) => {
      state.state_DriverCardDataResult_GetAllResult = rst;
    },
    SET_DRIVERCARDDATARESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_DriverCardDataResult_GetPageResult = rst;
    },
    SET_DRIVERCARDDATARESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_DriverCardDataResult_GetDetailResult = rst;
    },
    SET_DRIVERCARDDATARESULT_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_DriverCardDataResult_ModifyObjResult = rst;
    },
    SET_DRIVERCARDDATARESULT_GETMYPAGE_RESULT: (state, rst) => {
      state.state_DriverCardDataResult_GetMyPageResult = rst;
    },
    SET_DRIVERCARDDATARESULT_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_DriverCardDataResult_GetMyUserGroupPageResult = rst;
    },
    SET_DRIVERCARDDATARESULT_ADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_DriverCardDataResult_AddProcessRemarkResult = rst;
    },
  },
  actions: {
    DriverCardDataResultServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DRIVERCARDDATARESULT_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DRIVERCARDDATARESULT_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DriverCardDataResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DRIVERCARDDATARESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DRIVERCARDDATARESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DriverCardDataResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DRIVERCARDDATARESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DRIVERCARDDATARESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DriverCardDataResultServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DRIVERCARDDATARESULT_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DRIVERCARDDATARESULT_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DriverCardDataResultServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DRIVERCARDDATARESULT_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DRIVERCARDDATARESULT_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DriverCardDataResultServ_GetMyUserGroupPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DRIVERCARDDATARESULT_GETMYUSERGROUPPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DRIVERCARDDATARESULT_GETMYUSERGROUPPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DriverCardDataResultServ_AddProcessRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addProcessRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DRIVERCARDDATARESULT_ADDPROCESSREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DRIVERCARDDATARESULT_ADDPROCESSREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_DriverCardDataResult_GetAllResult: state => {
      return state.state_DriverCardDataResult_GetAllResult;
    },
    get_DriverCardDataResult_GetPageResult: state => {
      return state.state_DriverCardDataResult_GetPageResult;
    },
    get_DriverCardDataResult_GetDetailResult: state => {
      return state.state_DriverCardDataResult_GetDetailResult;
    },
    get_DriverCardDataResult_ModifyObjResult: state => {
      return state.state_DriverCardDataResult_ModifyObjResult;
    },
    get_DriverCardDataResult_GetMyPageResult: state => {
      return state.state_DriverCardDataResult_GetMyPageResult;
    },
    get_DriverCardDataResult_GetMyUserGroupPageResult: state => {
      return state.state_DriverCardDataResult_GetMyUserGroupPageResult;
    },
    get_DriverCardDataResult_AddProcessRemarkResult: state => {
      return state.state_DriverCardDataResult_AddProcessRemarkResult;
    },
  }
}